import { Component, effect, inject, OnInit } from '@angular/core';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { Category } from '../../../models/category';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { AlertStyleDirective } from '../../../directives/alert-style.directive';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DividerModule } from 'primeng/divider';
import { HeaderComponent } from '../../atoms/header/header.component';
import { IndicatorDataListComponent } from '../indicator-data-list/indicator-data-list.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SharedModule } from 'primeng/api';
import { CategoryStore } from '../../../stores/category/category.state';
import { AccordionModule } from 'primeng/accordion';
import { BadgeModule } from 'primeng/badge';
import { getState } from '@ngrx/signals';

@Component({
  selector: 'app-confirm-delete-category',
  standalone: true,
  imports: [
    AlertComponent,
    AlertStyleDirective,
    ButtonModule,
    ConfirmDialogModule,
    DividerModule,
    HeaderComponent,
    IndicatorDataListComponent,
    ScrollPanelModule,
    SharedModule,
    AccordionModule,
    BadgeModule,
  ],
  templateUrl: './confirm-delete-category.component.html',
  styleUrl: './confirm-delete-category.component.scss',
})
export class ConfirmDeleteCategoryComponent implements OnInit {
  readonly categoryStore = inject(CategoryStore);
  readonly indicatorStore = inject(IndicatorStore);
  categoryAndChildren: Category[] = [];
  categoryToDelete: Category | null = null;

  constructor() {
    effect(() => {
      const categoryState = getState(this.categoryStore);
      this.categoryToDelete = this.categoryStore.selectedItem();
      this.checkForData();
    });
  }

  /**
   * Lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   * This method initializes the component by setting the category to be deleted
   * and performing a check for required data.
   *
   * @return {void} Does not return a value.
   */
  ngOnInit(): void {
    this.categoryToDelete = this.categoryStore.selectedItem();
    this.checkForData();
  }

  /**
   * Checks for the presence of data related to the category to be deleted.
   * Retrieves child categories associated with the category and updates
   * a list containing the category and its children.
   *
   * @return {void} Does not return any value.
   */
  checkForData(): void {
    if (!this.categoryToDelete) return;
    const allChildren: Category[] = this.categoryStore.fetchCategoryChildren(
      this.categoryToDelete._id
    );
    this.categoryAndChildren = [...[this.categoryToDelete], ...allChildren];
  }
}
